// extracted by mini-css-extract-plugin
export default {"cta":"qF-z","disabled":"rF-z"};